import React from 'react'
import './nav.css'
import {AiFillHome} from 'react-icons/ai'
import {AiOutlineUser} from 'react-icons/ai'
import {FaStethoscope} from 'react-icons/fa'
import {RiMedicineBottleFill} from 'react-icons/ri'
import {MdRateReview} from 'react-icons/md'
import {AiFillPhone} from 'react-icons/ai'
import {useState} from 'react'

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <nav>
      <a href="#" onClick={() => setActiveNav('#')}className={activeNav === '#' ? 'active' : ''}><AiFillHome/></a>
      <a href="#about" onClick={() => setActiveNav('#about')} className = {activeNav === '#about' ? 'active' : ''}><AiOutlineUser/></a>
      <a href="#theDoctor"onClick={() => setActiveNav('#theDoctor')} className = {activeNav === '#theDoctor' ? 'active' : ''}><FaStethoscope/></a>
      <a href="#services" onClick={() => setActiveNav('#services')} className = {activeNav === '#services' ? 'active' : ''}><RiMedicineBottleFill/></a>
      <a href="#testimonials" onClick={() => setActiveNav('#testimonials')} className = {activeNav === '#testimonials' ? 'active' : ''}><MdRateReview/></a>
      <a href="#contact" onClick={() => setActiveNav('#contact')} className = {activeNav === '#contact' ? 'active' : ''}><AiFillPhone/></a>
    </nav>
  )
}

export default Nav